import { Container, Sprite } from "@pixi/react";
import { getGameImages } from "../../../helpers/getGameImages";

export const LinesIcon = () => {
    const { linesIcon } = getGameImages();

    const containerConfig = {
        x: 84,
        y: 363,
    }


    return (
        <Container {...containerConfig} name='LinesIconContainer'>
            <Sprite anchor={0} texture={linesIcon} />
        </Container>
    );
}